import YoutubeEmbed from "../YoutubeEmbed/YoutubeEmbed";
import icon1 from "../../assets/icon1.png";
import icon2 from "../../assets/icon2.png";
import icon3 from "../../assets/icon3.png";
import icon4 from "../../assets/icon4.png";
import icon5 from "../../assets/icon5.png";
import icon6 from "../../assets/icon6.png";
import "./Module.scss";

const Module = ({ embedId, moduleData, moduleTitle }) => (
  <div className="module-page">
    <div className="content">
      <h1>{moduleTitle}</h1>
      <div className="video-box">
        <div className="icon-border">
          <img src={icon1} alt=""></img>
          <img src={icon6} alt=""></img>
          <img src={icon3} alt=""></img>
        </div>
        <YoutubeEmbed embedId={embedId} />
        <div className="icon-border">
          <img src={icon4} alt=""></img>
          <img src={icon5} alt=""></img>
          <img src={icon2} alt=""></img>
        </div>
      </div>
      <div className="module-data">
        {Object.entries(moduleData).map(([title, content]) => {
          switch (content.type) {
            case "link":
              return (
                <div key={title}>
                  <h1>{title}</h1>
                  <a href={content.value}>{content.link_name}</a>
                </div>
              );
            case "text":
              return (
                <div key={title}>
                  <h1>{title}</h1>
                  <p>{content.value}</p>
                </div>
              );
            case "list":
              return (
                <div key={title}>
                  <h1>{title}</h1>
                  <ul>
                    {content.value.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
              );
            case "references":
              return (
                <div key={title}>
                  <h1>{title}</h1>
                  <ul className="refs">
                    {content.value.map((item, index) => (
                      <li className="reference" key={index}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            case "image_references":
              return (
                <div key={title}>
                  <h3>{title}</h3>
                  <ul className="refs">
                    {content.value.map((item, index) => (
                      <li className="reference" key={index}>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  </div>
);

export default Module;
